/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KsosOrderStatisticsInfoVo
 */
export interface KsosOrderStatisticsInfoVo {
    /**
     * 订单数量
     * @type {number}
     * @memberof KsosOrderStatisticsInfoVo
     */
    orderCount?: number;
    /**
     * sku数量
     * @type {number}
     * @memberof KsosOrderStatisticsInfoVo
     */
    skuCount?: number;
    /**
     * 订单ID列表
     * @type {Array<number>}
     * @memberof KsosOrderStatisticsInfoVo
     */
    orderIds?: Array<number>;
}

/**
 * Check if a given object implements the KsosOrderStatisticsInfoVo interface.
 */
export function instanceOfKsosOrderStatisticsInfoVo(value: object): value is KsosOrderStatisticsInfoVo {
    return true;
}

export function KsosOrderStatisticsInfoVoFromJSON(json: any): KsosOrderStatisticsInfoVo {
    return KsosOrderStatisticsInfoVoFromJSONTyped(json, false);
}

export function KsosOrderStatisticsInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KsosOrderStatisticsInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCount': json['orderCount'] == null ? undefined : json['orderCount'],
        'skuCount': json['skuCount'] == null ? undefined : json['skuCount'],
        'orderIds': json['orderIds'] == null ? undefined : json['orderIds'],
    };
}

export function KsosOrderStatisticsInfoVoToJSON(json: any): KsosOrderStatisticsInfoVo {
    return KsosOrderStatisticsInfoVoToJSONTyped(json, false);
}

export function KsosOrderStatisticsInfoVoToJSONTyped(value?: KsosOrderStatisticsInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCount': value['orderCount'],
        'skuCount': value['skuCount'],
        'orderIds': value['orderIds'],
    };
}

